<template>
    <div class="date-select">
        <div class="date-select__face" :class="{'date-select__face_open': open}" @click="open = !open">
            <span>{{getActiveItem ? getActiveItem : title}}</span>
            <svg>
                <use xlink:href="#svg-arrow-down"></use>
            </svg>
        </div>
        <transition name="fade">
            <PerfectScrollbar v-show="open" class="date-select__items">
                <span v-for="(item, i ) in result" class="date-select__item"
                      :class="{ 'date-select__item_active': item.active}"
                      @click="handlerChoiceOption(item, i)">{{item.value}}</span>
            </PerfectScrollbar>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'date-select',
        props: {
            result: {
                type: Array,
            },
            title: {
                type: String,
            },
        },
        data() {
            return {
                open: false,
                anotherClick: this.handlerAnotherClick.bind(this)
            }
        },
        computed: {

            getActiveItem() {
                return this.result?.find( el => typeof el.active === 'number')?.value;
            }
        },
        methods: {
            handlerChoiceOption({value}, i) {
                this.open = false;
                this.$emit('changeValue', typeof value !== 'string' ? value : i);
            },
            handlerAnotherClick({target}) {
                if (target.closest('.date-select') !== this.$el) {
                    this.open = false;
                }
            }
        },
        watch: {
            open(status) {
                if (status) {
                    document.body.addEventListener('click', this.anotherClick, true);
                } else {
                    document.body.removeEventListener('click', this.anotherClick, true);
                }

            }
        },
        updated() {
            // console.log( this.getActiveItem )
        }

    }
</script>

<style lang="scss" scoped>
    .date-select {
        position: relative;
        &__face{
            border: 1px solid #DFDFDF;
            padding: 16px;
            font-weight: 500;
            font-size: rem(16);
            line-height: 1;
            color: #757575;
            position: relative;
            &:hover{
                cursor: pointer;
            }
            span{
                margin-right: 10px;
            }
            svg{
                display: block;
                position: absolute;
                width: 12px;
                height: 12px;
                top: 50%;
                right: 24px;
                transform: translateY(-50%);
                transition: .2s all linear;
            }
            &_open{
                svg{
                    transform: translateY(-50%) rotate(180deg);
                }
            }
        }
        &__items{
            display: flex;
            flex-direction: column;
            position: absolute;
            top: calc(100% - 1px);
            left: 0;
            right: 0;
            z-index: 2;
            background-color: #fff;
            max-height: 200px;
            border: 1px solid #DFDFDF;
        }
        &__item{
            padding: 16px;
            transition: .2s linear background-color;
            &:hover{
                cursor: pointer;
                background-color: #DFDFDF;
            }
            &_active{
                background-color: #F7F8F9;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>